(function () {
  var root = document.querySelector('[data-booking]');
  var form = document.getElementById('BookingForm');
  var configElement = document.getElementById('BookingConfig');
  if (!root || !form || !configElement) return;

  var config;
  try {
    config = JSON.parse(configElement.textContent);
  } catch (error) {
    return;
  }

  var steps = Array.prototype.slice.call(form.querySelectorAll('[data-step]'));
  var progressSteps = Array.prototype.slice.call(root.querySelectorAll('.booking-progress__step'));
  var backButton = form.querySelector('[data-step-back]');
  var nextButton = form.querySelector('[data-step-next]');
  var submitButton = form.querySelector('[data-booking-submit]');
  var errorBox = form.querySelector('[data-step-error]');
  var dateStrip = form.querySelector('[data-date-strip]');
  var slotGrid = form.querySelector('[data-slot-grid]');
  var timezoneHint = form.querySelector('[data-tz-hint]');
  var variantInput = form.querySelector('[data-slot-variant]');
  var lagosPanel = form.querySelector('[data-lagos-place]');
  var dubaiPanel = form.querySelector('[data-dubai-place]');
  var dubaiHome = form.querySelector('[data-dubai-home]');
  var walkinNote = form.querySelector('[data-walkin-note]');
  var homeNote = form.querySelector('[data-home-note]');
  var homeAddress = form.querySelector('[data-home-address]');
  var distanceResult = form.querySelector('[data-distance-result]');
  var distanceText = form.querySelector('[data-distance-text]');
  var areaSelect = form.querySelector('[data-dubai-area]');
  var geoButton = form.querySelector('[data-geo-btn]');
  var summary = form.querySelector('[data-booking-summary]');
  var depositAmount = form.querySelector('[data-deposit-amount]');
  var currentStep = 0;
  var selectedDate = '';
  var selectedDateLabel = '';
  var selectedTime = '';

  var getChecked = function (name) {
    return form.querySelector('input[name="' + name + '"]:checked');
  };

  var ensureProperty = function (name, value) {
    var input = form.querySelector('input[name="properties[' + name + ']"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + name + ']';
      form.appendChild(input);
    }
    input.value = value || '';
  };

  var showError = function (message) {
    errorBox.textContent = message || '';
    errorBox.classList.toggle('is-visible', Boolean(message));
  };

  var city = function () {
    var checked = getChecked('booking_city');
    return checked ? checked.value : '';
  };

  var service = function () {
    if (city() === 'Dubai') {
      var tier = getChecked('booking_dubai_tier');
      return tier && tier.value === 'walkin' ? 'JVC studio appointment' : 'Dubai home service';
    }
    var location = getChecked('booking_location');
    return location ? location.value : 'Salon visit';
  };

  var activeProduct = function () {
    var slots = city() === 'Dubai' ? config.dubaiSlots : config.lagosSlots;
    if (!Array.isArray(slots)) return null;
    for (var i = 0; i < slots.length; i += 1) {
      if (slots[i][1]) return slots[i];
    }
    return slots[0] || null;
  };

  var syncPlace = function () {
    var isDubai = city() === 'Dubai';
    if (lagosPanel) lagosPanel.style.display = isDubai ? 'none' : '';
    if (dubaiPanel) dubaiPanel.style.display = isDubai ? '' : 'none';
    var dubaiTier = getChecked('booking_dubai_tier');
    var dubaiWalkin = Boolean(isDubai && dubaiTier && dubaiTier.value === 'walkin');
    var lagosLocation = getChecked('booking_location');
    var lagosHome = Boolean(!isDubai && lagosLocation && lagosLocation.value === 'Home service');
    if (dubaiHome) dubaiHome.style.display = dubaiWalkin ? 'none' : '';
    if (walkinNote) walkinNote.style.display = dubaiWalkin ? '' : 'none';
    if (homeNote) homeNote.style.display = lagosHome ? '' : 'none';
    if (homeAddress) homeAddress.style.display = lagosHome || Boolean(isDubai && !dubaiWalkin) ? '' : 'none';
    var product = activeProduct();
    if (variantInput && product) variantInput.value = product[2];
    renderDates();
  };

  var dateKey = function (date) {
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var day = String(date.getDate()).padStart(2, '0');
    return year + '-' + month + '-' + day;
  };

  var dateLabel = function (date) {
    return date.toLocaleDateString('en', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
  };

  var renderDates = function () {
    if (!dateStrip) return;
    selectedDate = '';
    selectedDateLabel = '';
    selectedTime = '';
    var closedDays = Array.isArray(config.closedDays) ? config.closedDays.map(Number) : [];
    var leadHours = Number(config.leadHours) || 3;
    var threshold = new Date(Date.now() + leadHours * 60 * 60 * 1000);
    var html = '';
    var count = 0;
    for (var offset = 0; offset < 28 && count < 14; offset += 1) {
      var date = new Date();
      date.setHours(12, 0, 0, 0);
      date.setDate(date.getDate() + offset);
      if (closedDays.indexOf(date.getDay()) !== -1) continue;
      if (offset === 0 && threshold.getHours() >= 19) continue;
      var key = dateKey(date);
      html += '<label class="date-chip"><input type="radio" name="booking_date" value="' + key + '"><span><small>' + config.dayNames[date.getDay()] + '</small><strong>' + date.getDate() + '</strong><small>' + config.monthNames[date.getMonth()] + '</small></span></label>';
      count += 1;
    }
    dateStrip.innerHTML = html || '<p class="slot-empty">No bookable dates are currently available.</p>';
    if (slotGrid) slotGrid.innerHTML = '<p class="slot-empty">Pick a date first.</p>';
  };

  var renderTimes = function (key) {
    if (!slotGrid || !key) return;
    var selected = new Date(key + 'T12:00:00');
    var isDubai = city() === 'Dubai';
    var startHour = isDubai ? 10 : 9;
    var endHour = isDubai ? 20 : 19;
    var increment = isDubai ? 90 : 60;
    var leadHours = Number(config.leadHours) || 3;
    var threshold = new Date(Date.now() + leadHours * 60 * 60 * 1000);
    var html = '';
    for (var minutes = startHour * 60; minutes <= endHour * 60; minutes += increment) {
      var hour = Math.floor(minutes / 60);
      var minute = minutes % 60;
      var slotDate = new Date(selected);
      slotDate.setHours(hour, minute, 0, 0);
      if (slotDate < threshold) continue;
      var suffix = hour >= 12 ? 'PM' : 'AM';
      var displayHour = hour % 12 || 12;
      var display = displayHour + ':' + String(minute).padStart(2, '0') + ' ' + suffix;
      html += '<label class="slot"><input type="radio" name="booking_time" value="' + display + '"><span>' + display + '</span></label>';
    }
    slotGrid.innerHTML = html || '<p class="slot-empty">No times remain for this date. Please choose another day.</p>';
    selectedTime = '';
    if (timezoneHint) timezoneHint.textContent = isDubai ? '(Dubai time, GST)' : '(Lagos time, WAT)';
  };

  var updateProgress = function () {
    steps.forEach(function (step, index) {
      step.classList.toggle('is-active', index === currentStep);
      step.setAttribute('aria-hidden', index === currentStep ? 'false' : 'true');
    });
    progressSteps.forEach(function (step, index) {
      step.classList.toggle('is-active', index === currentStep);
      step.classList.toggle('is-done', index < currentStep);
    });
    backButton.style.visibility = currentStep === 0 ? 'hidden' : 'visible';
    nextButton.style.display = currentStep === steps.length - 1 ? 'none' : '';
    submitButton.style.display = currentStep === steps.length - 1 ? '' : 'none';
    showError('');
    if (currentStep === steps.length - 1) buildSummary();
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  var validateStep = function () {
    if (currentStep === 0 && !city()) return 'Choose Lagos or Dubai to continue.';
    if (currentStep === 1 && city() === 'Dubai') {
      var tier = getChecked('booking_dubai_tier');
      if (tier && tier.value === 'home' && areaSelect && !areaSelect.value) return 'Choose your Dubai area to continue.';
    }
    if (currentStep === 2 && !getChecked('booking_style')) return 'Choose a style or select “Not sure yet”.';
    if (currentStep === 3 && !selectedDate) return 'Choose a booking date.';
    if (currentStep === 3 && !selectedTime) return 'Choose an available time.';
    if (currentStep === 4) {
      var name = form.querySelector('input[name="properties[Name]"]');
      var phone = form.querySelector('input[name="properties[Phone]"]');
      if (!name || !name.value.trim()) return 'Enter your full name.';
      if (!phone || phone.value.replace(/\D/g, '').length < 7) return 'Enter a valid phone number.';
    }
    return '';
  };

  var buildSummary = function () {
    var selectedStyle = getChecked('booking_style');
    var selectedArea = areaSelect && areaSelect.value ? areaSelect.value : '';
    var travel = distanceText && distanceResult && distanceResult.style.display !== 'none' ? distanceText.textContent : selectedArea;
    ensureProperty('City', city());
    ensureProperty('Service', service());
    ensureProperty('Style', selectedStyle ? selectedStyle.value : '');
    ensureProperty('Date', selectedDateLabel);
    ensureProperty('Time', selectedTime);
    ensureProperty('Timezone', city() === 'Dubai' ? 'GST (UTC+4)' : 'WAT (UTC+1)');
    ensureProperty('Travel estimate', travel);
    var product = activeProduct();
    if (variantInput && product) variantInput.value = product[2];
    var rows = [
      ['City', city()],
      ['Service', service()],
      ['Style', selectedStyle ? selectedStyle.value : ''],
      ['Appointment', selectedDateLabel + ' · ' + selectedTime]
    ];
    if (selectedArea) rows.push(['Area', selectedArea]);
    summary.innerHTML = rows.map(function (row) {
      return '<div class="booking-summary__row"><dt>' + row[0] + '</dt><dd>' + row[1] + '</dd></div>';
    }).join('');
    if (depositAmount && product) {
      var amount = city() === 'Dubai' ? 'US$10' : 'US$1';
      depositAmount.textContent = amount;
    }
  };

  form.addEventListener('change', function (event) {
    if (event.target.name === 'booking_city' || event.target.name === 'booking_location' || event.target.name === 'booking_dubai_tier') syncPlace();
    if (event.target.name === 'booking_date') {
      selectedDate = event.target.value;
      selectedDateLabel = dateLabel(new Date(selectedDate + 'T12:00:00'));
      renderTimes(selectedDate);
    }
    if (event.target.name === 'booking_time') selectedTime = event.target.value;
    showError('');
  });

  nextButton.addEventListener('click', function () {
    var message = validateStep();
    if (message) {
      showError(message);
      return;
    }
    currentStep = Math.min(steps.length - 1, currentStep + 1);
    updateProgress();
  });

  backButton.addEventListener('click', function () {
    currentStep = Math.max(0, currentStep - 1);
    updateProgress();
  });

  if (areaSelect) {
    areaSelect.addEventListener('change', function () {
      var option = areaSelect.options[areaSelect.selectedIndex];
      var kilometers = Number(option.getAttribute('data-km')) || 0;
      if (!areaSelect.value || !distanceResult || !distanceText) return;
      var fee = Number(config.feeBase || 15) + kilometers * Number(config.feePerKm || 1.5);
      distanceText.textContent = areaSelect.value + ' · estimated travel fee AED ' + Math.round(fee);
      distanceResult.style.display = '';
    });
  }

  if (geoButton) {
    geoButton.addEventListener('click', function () {
      if (!navigator.geolocation) {
        showError('Location access is not available in this browser. Choose your area instead.');
        return;
      }
      geoButton.disabled = true;
      geoButton.textContent = 'Finding your location…';
      navigator.geolocation.getCurrentPosition(function (position) {
        var radians = function (degrees) { return degrees * Math.PI / 180; };
        var latitude = position.coords.latitude;
        var longitude = position.coords.longitude;
        var deltaLatitude = radians(latitude - config.dubaiBase[0]);
        var deltaLongitude = radians(longitude - config.dubaiBase[1]);
        var a = Math.sin(deltaLatitude / 2) * Math.sin(deltaLatitude / 2) + Math.cos(radians(config.dubaiBase[0])) * Math.cos(radians(latitude)) * Math.sin(deltaLongitude / 2) * Math.sin(deltaLongitude / 2);
        var kilometers = 6371 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var fee = Number(config.feeBase || 15) + kilometers * Number(config.feePerKm || 1.5);
        distanceText.textContent = kilometers.toFixed(1) + ' km from JVC · estimated travel fee AED ' + Math.round(fee);
        distanceResult.style.display = '';
        geoButton.disabled = false;
        geoButton.textContent = 'Location found';
      }, function () {
        geoButton.disabled = false;
        geoButton.textContent = 'Use my exact location';
        showError('We could not access your location. Choose your area instead.');
      }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 });
    });
  }

  form.addEventListener('submit', function (event) {
    buildSummary();
    if (!variantInput || !variantInput.value) {
      event.preventDefault();
      showError('The booking deposit is temporarily unavailable. Please contact us directly.');
    }
  });

  syncPlace();
  updateProgress();
})();
